import { UserRoles } from "@/interfaces";
import { PlanFeatureNames, PlanFeatures } from "@/interfaces/plan";

interface PermissionsProps {
  userRole: UserRoles;
  planFeatures: PlanFeatures[];
}

export function usePermissions({ userRole, planFeatures }: PermissionsProps) {
  const isAdminOrOwner = [UserRoles.ADMIN, UserRoles.OWNER].includes(userRole);

  const hasFeature = (featureName: PlanFeatureNames): boolean => {
    return planFeatures?.some((feature) => {
      return feature.name === featureName && feature.value === "true";
    });
  };

  return {
    canAccessDashboard:
      isAdminOrOwner && hasFeature(PlanFeatureNames.DISPLAY_DASHBOARD),
    canAccessDelinquency:
      isAdminOrOwner && hasFeature(PlanFeatureNames.DISPLAY_DELINQUENCY),
    canAccessCalendar: hasFeature(PlanFeatureNames.DISPLAY_CALENDAR),
    canAccessMenu: hasFeature(PlanFeatureNames.DISPLAY_MENU),
  };
}
